import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from "../../../base.component";
import {AddOrUpdateCategoryOptions} from "./options/add-or-update-category.options";
import {MatDialogRef} from "@angular/material/dialog";
import {DataResponse} from "../../../../network/service/data.response";
import {SnackBarUtil} from "../../../../util/snack.bar.util";

@Component({
  selector: 'app-add-or-update-category',
  standalone: false,
  templateUrl: './add-or-update-category.component.html',
  styleUrls: ['./add-or-update-category.component.scss']
})
export class AddOrUpdateCategoryComponent extends BaseComponent implements OnInit {
  addOrUpdateCategoryOptions = new AddOrUpdateCategoryOptions();
  title?: string;
  order?: number;
  branchIds?: string;
  type?: string;
  isActive?: boolean;
  parentId?: string;
  iconFile?: any;
  icon?: any;
  megaMenuIconFile?: any;
  megaMenuIcon?: any;
  bannerFile?: any;
  banner?: any;
  selectedBranches?: any = [];

  constructor(injector: Injector, private readonly matDialogRef: MatDialogRef<AddOrUpdateCategoryComponent>) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.title = this.addOrUpdateCategoryOptions.category.Title;
    this.order = this.addOrUpdateCategoryOptions.category.Order;
    this.type = this.addOrUpdateCategoryOptions.category.Type;
    this.isActive = this.addOrUpdateCategoryOptions.category.IsActive;
    this.parentId = this.addOrUpdateCategoryOptions.category.ParentId;
    this.icon = this.addOrUpdateCategoryOptions.category.Icon;
    if (this.icon) {
      this.iconFile = [{
        name: this.addOrUpdateCategoryOptions.category.Icon
      }];
    }
    this.megaMenuIcon = this.addOrUpdateCategoryOptions.category.MegaMenuIcon;
    if (this.megaMenuIcon) {
      this.megaMenuIconFile = [{
        name: this.addOrUpdateCategoryOptions.category.MegaMenuIcon
      }];
    }
    this.banner = this.addOrUpdateCategoryOptions.category.Banner;
    if (this.banner) {
      this.bannerFile = [{
        name: this.addOrUpdateCategoryOptions.category.Banner
      }];
    }
    this.selectedBranches = this.addOrUpdateCategoryOptions.category.CategoryBranches.map((categoryBranch: any) => {
      return categoryBranch.Branch;
    });
    this.branchIds = this.addOrUpdateCategoryOptions.category.BranchIds;
  }

  override loadOnline() {
    super.loadOnline();
  }

  noAction() {
    this.matDialogRef.close();
  }

  onSubmitClicked() {
    if (this.isRequiredFieldsFilled(this.title, this.iconFile)) {
      this.upload((this.iconFile ?? [])[0], (fileId: string) => {
        this.icon = fileId;
        this.upload((this.megaMenuIconFile ?? [])[0], (fileId: string) => {
          this.megaMenuIcon = fileId;
          (this.addOrUpdateCategoryOptions.category.CategoryId !== undefined ? this.serviceApi.updateCategories(this.addOrUpdateCategoryOptions.category.CategoryId, {
            Title: this.title,
            Order: this.order,
            IsActive: this.isActive,
            Icon: this.icon,
            MegaMenuIcon: this.megaMenuIcon,
            BranchIds: this.branchIds,
          }) : this.serviceApi.createCategories({
            Title: this.title,
            Order: this.order,
            IsActive: this.isActive,
            Icon: this.icon,
            MegaMenuIcon: this.megaMenuIcon,
            BranchIds: this.branchIds,
          })).subscribe((res: DataResponse<any>) => {
            if (res.success) {
              this.addOrUpdateCategoryOptions.onInsertOrUpdateFinished();
              this.noAction();
            } else {
              SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
            }
          });
        });
      });
    }
  }

  upload(file: any, callback: any) {
    if (file) {
      if (file instanceof File) {
        let formData = new FormData();
        formData.append('File', file);
        this.serviceApi.upload(formData).subscribe((res: DataResponse<any>) => {
          if (res.success) {
            callback(res.data.dataValues.FileId);
          } else {
            SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
          }
        });
      } else {
        callback(file.name);
      }
    } else {
      callback(null);
    }
  }
}
